import { ListFilter } from '../components/List';
import { filters, filtersIds } from './filters';
import { typesIds } from './types';

const getFilterById = (filterId: string) =>
  filters.find(({ id }) => id === filterId) || ({} as ListFilter);

export const categoriesIds = {
  whatsNew: 'whats-new',
  yourNotifications: 'your-notifications',
  yourDownloads: 'downloads',
};

export type NotificationsCategory = {
  id: string;
  label: string;
  types: Array<string>;
  filters: Array<ListFilter>;
  initial?: boolean;
};

export const categories: Array<NotificationsCategory> = [
  {
    id: categoriesIds.whatsNew,
    label: "What's new!",
    filters: [getFilterById(filtersIds.all), getFilterById(filtersIds.favourites)],
    types: [typesIds.whatsNew],
  },
  {
    id: categoriesIds.yourNotifications,
    label: 'Your notifications',
    filters: [
      getFilterById(filtersIds.all),
      getFilterById(filtersIds.downloads),
      getFilterById(filtersIds.responses),
      getFilterById(filtersIds.favourites),
      getFilterById(filtersIds.uploads),
    ],
    types: [
      typesIds.accountNotification,
      typesIds.systemUpdate,
      typesIds.response,
      typesIds.downloads,
      typesIds.uploads,
    ],
    initial: true,
  },
];

const { id: initialCategory } = categories.find(({ initial }) => initial) || { id: undefined };

const initialFilter = categories.find(({ id }) => id === initialCategory)?.filters[0]?.id;

export { initialCategory, initialFilter };
